<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import { useAuthStore } from '@/stores/useAuthStore'

const { t } = useI18n()
const { umsokn } = useUmsokn() // ref
const auth = useAuthStore()

const props = defineProps<{
  disable?: boolean
  handleNext?: () => void
  handlePrev?: () => void
}>()

// --- Validation ---
const rules = {
  umsokn: {
    confirmFyrirvarar: { sameAs: sameAs(true) },
  },
}

const v$ = useVuelidate(rules, { umsokn })

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  },
})
</script>

<template>
  <div v-if="umsokn">
    <v-row>
      <v-col>
        <h2 class="form__header" id="#style-2">
          {{ t('radstofun_idgjalds_step5_header') }}
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <div
        class="div_overflow scrollbar"
        v-html="t('umsokn_tilgreind_sereign_step5_tilgreind_fyrirvari')"
      ></div>
    </v-row>

    <v-row>
      <v-col>
        <v-checkbox
          v-model="umsokn.confirmFyrirvarar"
          :label="t('umsokn_tilgreind_sereign_step5_confirm')"
          :readonly="props.disable"
          density="comfortable"
          :error="v$.umsokn.confirmFyrirvarar.$error"
          :error-messages="
            v$.umsokn.confirmFyrirvarar.$error
              ? [t('umsokn_tilgreind_sereign_step5_confirm_error')]
              : []
          "
        />
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>
input {
  width: 100%;
}
.forms__fadein {
  opacity: 0;
  -moz-transition: opacity 0.4s ease-in-out;
  -o-transition: opacity 0.4s ease-in-out;
  -webkit-transition: opacity 0.4s ease-in-out;
  transition: opacity 0.4s ease-in-out;
}
.forms__fadeout {
  opacity: 1;
}
.slideup,
.slidedown {
  max-height: 0;
  overflow: hidden;
  width: 100%;
  -webkit-transition: max-height 0.8s ease-in-out;
  -moz-transition: max-height 0.8s ease-in-out;
  -o-transition: max-height 0.8s ease-in-out;
  transition: max-height 0.8s ease-in-out;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
  border-radius: 10px;
  background-color: #f5f5f5;
}
.div_overflow {
  height: 500px !important;
  overflow-y: scroll;
  border: 1px solid #e5e5e5;
  padding: 20px;
}
#style-2::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
#style-2::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}
#style-2::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #d62929;
}
.slidedown {
  max-height: 500px;
}
</style>
